export class AppConfig {
    //VIMEO LAB
    public static apiAdresaMongoVimeo='https://lab.fortuno.hr:9011/';
    //VIMEO PRODUKCIJA
    //public static apiAdresaMongoVimeo='https://dl.holspico.hr:9011/';

    //VIRTUALNA UČIONICA LAB
    public static IPfile='https://lab.fortuno.hr:3022';
    public static apiAdresaSQL='https://lab.fortuno.hr:3022/api/';

    //VIRTUALNA UČIONICA PRODUKCIJA
    //public static IPfile='https://dl.holspico.hr:3012';
    //public static apiAdresaSQL='https://dl.holspico.hr:3012/api/';
}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/config.ts